import * as React from "react";
import { useParams, Link as RouterLink } from "react-router-dom";
import { SimpleBreadcrumbs } from "../../../../../components/navigation/simpleBreadcrumbs";
import { Typography, Link, Stack  } from "@mui/material";
import DetailPage, { DetailPageTab } from "../../../../../components/common/detailPage/detailPage";
import TrainerEntryDataGrid from "./trainerEntryDataGrid";
import { cclTokenedPayrollApi } from "../../../../../services/cclTokenedPayrollApi";

export type TrainerEntryDetailProps = {
    id: string;
    sessionId: string;
};

export const TrainerEntryDetail: React.FC = (props) => {
    const params = useParams<TrainerEntryDetailProps>();
    const workEntryId = params.id !== undefined ? params.id : "";
    const sessionId = params.sessionId !== undefined ? params.sessionId : "";

    const {data: workEntryData } = cclTokenedPayrollApi.useGetWorkEntryByIdQuery(workEntryId);

    const tablist: DetailPageTab[] = [
        // {
        //     label: "General",
        //     index: 0,
        //     content: (
        //         <TrainerEntryDataGrid sessionId={sessionId} workEntryData={workEntryData} />
        //     ),
        //     visible: true,
        // }
    ];

    const breadcrumbs = (
        <Stack direction={"row"} spacing={3}>
            <SimpleBreadcrumbs>
                <Typography variant="h6" color="text.primary">
                    <Link key="findSessionLink" component={RouterLink} to={`/session/${sessionId}/12`}>
                        Session Details
                    </Link>
                </Typography>
                <Typography variant="h6" color="text.primary">Work Entry Details</Typography>
            </SimpleBreadcrumbs>
        </Stack>
    );
    

    return (
        <DetailPage tablist={tablist} breadcrumbs={breadcrumbs} descriptor={""} />
    );
};

export default TrainerEntryDetail;
